'use client';
import { RadioProps } from '@mui/material';
import { RadioStyled } from './radio.styles';

const Radio = (props: RadioProps): JSX.Element => {
  const { color } = props;
  const colorByDefault = color || 'default';

  const template = <RadioStyled {...props} color={colorByDefault} />;

  return template;
};

export default Radio;
